module.exports = __webpack_public_path__ + "img/logo-primary.09dfbdb8.png";